import React from 'react';
import './UsersTableKPIBackend.css';

export default function UsersTableKPIBackend({ usersStats = [] }) {
  // Ensure usersStats is always an array
  const safeUsersStats = Array.isArray(usersStats) ? usersStats : [];
  
  if (!safeUsersStats || safeUsersStats.length === 0) {
    return (
      <div className="users-table-container">
        <h3 className="users-table-title">Activité des Utilisateurs</h3>
        <div className="users-table-empty">
          Aucune donnée d'utilisateur disponible pour cette période
        </div>
      </div>
    );
  }

  return (
    <div className="users-table-container">
      <h3 className="users-table-title">Activité des Utilisateurs</h3>
      
      <div className="users-table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>Utilisateur</th>
              <th>Fréquence</th>
              <th>Projets</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {safeUsersStats.map((user, index) => (
              <tr key={index} className={`user-row ${user.status ? user.status.toLowerCase() : ''}`}>
                <td className="user-email">
                  <div className="user-email-text">
                    {user.user || 'Unknown'}
                  </div>
                  <div className="user-session-count">
                    {user.sessionCount || 0} session{(user.sessionCount || 0) > 1 ? 's' : ''}
                  </div>
                </td>
                <td className="user-frequency">
                  <span className={`frequency-badge frequency-${(user.frequency || 'inactif').toLowerCase().replace(/[^\w]/g, '')}`}>
                    {user.frequency || 'Inactif'}
                  </span>
                </td>
                <td className="user-projects">
                  <div className="projects-count">
                    {user.projects || 0}
                  </div>
                </td>
                <td className="user-status">
                  <span className={`status-badge status-${(user.status || 'inactif').toLowerCase()}`}>
                    {user.status || 'Inactif'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
